<template>
  <div class="paywall">
    <iframe ref="frame" :src="source" seamless frameborder="0"></iframe>
  </div>
</template>

<script>
  export default {
    props: {
      articleId: {
        type: String,
        required: true,
      },
      articleUrl: {
        type: String,
        required: true,
      },
      layout: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        host: 'https://www.dn.no',
        styles: {
          feature: '/kundeservice/external/v1/subscribe-entrance-magazine',
          regular: '/kundeservice/external/v1/subscribe-entrance',
        }
      };
    },
    computed: {
      source() {
        let host = this.styles[this.layout];
        host = process.env.NODE_ENV === 'development' ? 'https://www.dn.no' + host : host;
        return `${host}?articleUrl=${this.articleUrl}&section=staticprojects&articleId=${this.articleId}`;
      }
    },
    mounted() {
      window.addEventListener('message', (event) => {
        if (event.data && event.data['iframe-height']) {
          this.$refs['frame'].style.height = `${event.data['iframe-height']}px`;
        }
      }, false);
    }
  };
</script>

<style lang="scss">
  @import 'scss/base';

  .paywall {
    position: relative;
    background-color: #f4f4f4;

    iframe {
      width: 100%;
      min-height: 670px;
      overflow: hidden;
      border: none;
      margin: 0;
      padding: 0;

      @media #{$grid-lg-up} {
        min-height: 630px;
      }
    }
  }
</style>